import { apiService } from 'core/services';
import { createAppAsyncThunk } from 'core/store/store.helpers';

export const fetchAllPriceGroups = createAppAsyncThunk('fetchAllPriceGroups', async () =>
  apiService.masterEntities.getPriceGroupList(),
);

export const fetchAllPriceGroupsReducer = builder =>
  builder
    .addCase(fetchAllPriceGroups.pending, state => {
      state.isLoading = true;
    })
    .addCase(fetchAllPriceGroups.rejected, state => {
      state.isLoading = false;
      state.priceGroups = [];
    })
    .addCase(fetchAllPriceGroups.fulfilled, (state, action) => {
      state.priceGroups = action.payload;
      state.isLoading = false;
    });
